import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, Modal } from "reactstrap";
import { Trans } from 'react-i18next';
import React, { useCallback, useRef, useState, useEffect } from 'react';
import { GoogleMap, useJsApiLoader, Polygon, StandaloneSearchBox } from '@react-google-maps/api';
const containerStyle = {
  width: '100%',
  height: '600px'
};

const libs = ['maps', 'places'];
const MapComponent = ({boundries, setBoundries, changed, setChanged}) => {
    const [overlappingError, setOverlappingError] = useState(false);
    const [searchBox, setSearchBox] = useState(null);
    const [zoom, setZoom] = useState(10);
    const [editMode, setEditMode] = useState(false);
    const [oldVertexes, setOldVertexes] = useState([]);
    const [area, setArea] = useState([]);
    const [center, setCenter] = useState({
      lat: 24.712186535213522,
      lng: 55.11976906855254
    });
      const inputStyle = {
        boxSizing: `border-box`,
        border: `1px solid transparent`,
        width: `240px`,
        height: `32px`,
        padding: `0 12px`,
        borderRadius: `3px`,
        boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
        fontSize: `14px`,
        outline: `none`,
        textOverflow: `ellipses`,
        position: 'absolute',
        top: '10px',
        right: '10px',
      }
  useEffect(()=>{ 
    setTimeout(()=>{
      require('../../common/map-contains.js');
    },1000)
  },[]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyB_0WjJZTplrgiW8rTo3TWx97u-C1WutB0',
    libraries: libs
  });

  const addRegion = () => {
    const temp = boundries;
    temp.push([
        { lat: 24.712186535213522, lng: 55.11976906855254 },
        { lat: 24.712186535213522, lng: 55.23976906855254 },
        { lat: 24.872186535213522, lng: 55.23976906855254 },
        { lat: 24.872186535213522, lng: 55.11976906855254 }
        ]);
    setBoundries(temp);
    setChanged(!changed);

    // console.log('add region',boundries)
  }
  const clearRegion = () => {
    const temp = [];
    // temp.push([
    //     { lat: 24.712186535213522, lng: 55.11976906855254 },
    //     { lat: 24.712186535213522, lng: 55.23976906855254 },
    //     { lat: 24.862186535213522, lng: 55.23976906855254 },
    //     { lat: 24.872186535213522, lng: 55.11976906855254 }
    //     ]);
    setBoundries(temp);
    setChanged(!changed);
  }
  const onEdit = useCallback((e,index) => {
    const v = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng()
    };
    const temp = [...boundries];
    // for(let i=0; i<temp.length;i++)
    // {
    //   const a = new google.maps.Polygon({
    //     paths: temp[i],
    //     strokeColor: "#000000",
    //     strokeOpacity: 0.8,
    //     strokeWeight: 1.5,
    //     fillColor: "#ff0000",
    //     fillOpacity: 0.35,
    //       });      
    //     // console.log('check',a,a.containsLatLng(e.latLng.lat(),e.latLng.lng()));
    //     if(a.containsLatLng(v.lat,v.lng))
    //     {
    //       setOverlappingError(true);
    //       return;
    //     }
    //   }
    setOverlappingError(false);
    //realign vertex

    if(!temp[index]) return;
    const newPath = temp[index];
    if(!e.vertex && e.edge)
      newPath.splice(e.edge+1, 0, v);
    else
      newPath[e.vertex] = v;
    temp[index] = newPath;
    console.log('edited path',temp, e);
    setOldVertexes(temp);
    setBoundries(temp);
    // setChanged(!changed);
  }, []);

  const handleLoad = aref => {
    setSearchBox(aref);
  }

  const hanldePlacesChanged = ref => {
      setCenter({
        lat: searchBox.getPlaces()[0].geometry.location.lat(),
        lng: searchBox.getPlaces()[0].geometry.location.lng(),
      });
      setZoom(14);
  }

  const addArea = (e) => {
    if(!editMode)
      return;
    const temp = [...area];
    temp.push({lat: e.latLng.lat(), lng: e.latLng.lng()});
    setArea(temp);
    // if(area.length >3 )
    // {
    //   const t = [...boundries];
    //   t.push(area);
    //   setBoundries(t);
    //   setArea([]);
    //   setEditMode(false);
    //   setChanged(!changed);
    // }
  }

  const editStartStop = (e) => {
    if(editMode)
    {
      const t = [...boundries];
      t.push(area);
      setBoundries(t);
      setEditMode(false);
      setChanged(!changed);

    }
    setEditMode(!editMode);
    setArea([]);
  }

  return isLoaded ? (
    <Row >
        <div className="text-center  mt-4 col-md-12">
              <Button type="button" color="success" onClick={addRegion} className="mx-3">
                <Trans>Add region</Trans>
              </Button>
              <Button type="button" color="warning" onClick={clearRegion} className="mx-3">
                <Trans>Clear region</Trans>
              </Button>
              <Button type="button" color={editMode?'danger':'success'} onClick={editStartStop} className="mx-3">
                <Trans>Add Points {editMode?'On':'Off'}</Trans>
              </Button>
        </div>
        <div className="text-center  mt-2 col-md-12">
        {overlappingError?<Alert  color="danger" >{"Warning : Overlapping, will not be saved!"}</Alert> : null}
        </div>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
          libraries={libs}
          onClick={addArea}
        >
          <StandaloneSearchBox onPlacesChanged={hanldePlacesChanged} onLoad={handleLoad} >
            <input
              type='text'
              placeholder='Search location'
              style={inputStyle}
            />
          </StandaloneSearchBox>          
          {
            boundries?boundries?.map((path,index) => (
              <Polygon key={index}
              paths={path}
              editable={true}
              draggable={true}
              onMouseUp={(e)=>onEdit(e,index)}
            />
      
            )
          ):null
          }
        </GoogleMap>
    </Row>
  ) : <></>;
};
export default MapComponent;